'use strict';

const _=require('pulsar-utils/dist-es6/_');
const PersonStatisticsViewModel=require('../../../dist-es6/client/viewModels/personStatisticsViewModel');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const AlertStatusCache=require('../../../dist-es6/client/viewModels/alertStatusCache');
const ex=require('pulsar-utils/dist-es6/ex');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const Formatters=require('../../../dist-es6/client/formatters');

const THREE_HOURS_IN_MS=timespan.fromHours(3).totalMilliseconds();let

DashboardPersonViewModel=class DashboardPersonViewModel extends PersonStatisticsViewModel{
constructor(...args){
super(...args);
this._thresholdCacheValue=void 0;
this._statusCache=new AlertStatusCache(nt=>this._thresholdStatusFor(nt));
this._isStaleValue=void 0;
this._currentStatusSource='lastKnownStatus';
}

get _thresholdCache(){
if(!_.exists(this._thresholdCacheValue)){
const recentFatigueHistory={
averageDailyLow:this.averageDailyLow,
averageDailyHigh:this.averageDailyHigh,
topDailyHighs:this.topDailyHighs};


this._thresholdCacheValue=ThresholdStatus.getEffectiveThresholdsForMultipleGroups(this.groupMembershipsAtScope,recentFatigueHistory);
}

return this._thresholdCacheValue;
}

_thresholdStatusFor(notificationType){
return ThresholdStatus.fromScoreAndThreshold(this.fatigueAlertScore,this._thresholdCache.get(notificationType));
}

thresholdFor(notificationType){
return this._thresholdCache.get(notificationType);
}

thresholdStatusFor(notificationType){
return this._statusCache.get(notificationType);
}

get currentStatus(){
return _.get(this,this._currentStatusSource,{});
}

get fatigueAlertScore(){
return _.get(this,this._currentStatusSource+'.fatigue');
}

get lastKnownStatus(){
return this._statistics.lastKnownStatus;
}

get lastKnownDutyStatus(){
return Formatters.dutyStatusFromLastKnownStatus(this.lastKnownStatus);
}

get lastKnownLocationDescription(){
return this.lastKnownStatus.location.description;
}

get averageDailyLow(){
return ex(this,this._currentStatusSource+'.statistics.recentHistory.fatigue.averageDailyLow').otherwise(null);
}

get averageDailyHigh(){
return ex(this,this._currentStatusSource+'.statistics.recentHistory.fatigue.averageDailyHigh').otherwise(null);
}

get topDailyHighs(){
return ex(this,this._currentStatusSource+'.statistics.recentHistory.fatigue.topDailyHighs').otherwise(null);
}

get estimatesAsOfTime(){
return this._statistics.estimatesAsOfTime;
}

get isStale(){
if(!_.exists(this._isStaleValue)){
this._isStaleValue=_.exists(this._statistics[this._currentStatusSource].time)&&Date.now()-this._statistics[this._currentStatusSource].time.getTime()>THREE_HOURS_IN_MS;
}

return this._isStaleValue;
}

get timeOfLastPointBeforeTruncation(){
if(_.exists(this._timeOfLastPointBeforeTruncation)){
return this._timeOfLastPointBeforeTruncation;
}

const currentStatus=this._statistics[this._currentStatusSource];

const{estimatesAsOfTime,currentHosStatus}=this;

if(!_.exists(currentStatus,'time')||!_.exists(estimatesAsOfTime)){
return this._timeOfLastPointBeforeTruncation=!1;
}

if(_.exists(currentHosStatus)){
return this._timeOfLastPointBeforeTruncation=currentStatus.time.getTime()-currentHosStatus.time.getTime()===EightHoursInMilliseconds?
currentHosStatus.time:!1;

}else if(currentStatus.time.getTime()<estimatesAsOfTime.getTime()){
return this._timeOfLastPointBeforeTruncation=new Date(currentStatus.time.getTime()-EightHoursInMilliseconds);
}

return this._timeOfLastPointBeforeTruncation=!1;
}};


const EightHoursInMilliseconds=timespan.fromHours(8).totalMilliseconds();

module.exports=DashboardPersonViewModel;
//# sourceMappingURL=dashboardPersonViewModel.js.map
